import React from "react";

export const getJsonLd = ({ slug }) => {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": ["Organization"],
        "@id": "https://soulscale.org/#organization",
        name: "Soul Scale",
        url: "https://soulscale.org/",
        email: "admin",
        logo: {
          "@type": "ImageObject",
          "@id": "https://soulscale.org/#logo",
          url: "https://soulscale.org/images/logo.webp",
          contentUrl: "https://soulscale.org/images/logo.webp",
          caption: "Soul Scale",
          inLanguage: "en-US",
          width: "112",
          height: "112",
        },
      },
      {
        "@type": "WebSite",
        "@id": "https://soulscale.org/#website",
        url: "https://soulscale.org",
        name: "Soul Scale",
        publisher: {
          "@id": "https://soulscale.org/#organization",
        },
        inLanguage: "en-US",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://soulscale.org/?s={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "WebPage",
        "@id": "https://soulscale.org/#webpage",
        url: `https://soulscale.org/${slug}`,
        name: "Soul Scale | Consulting that Strengthens the Development Sector — Finance, Research and Climate Solutions for Informal Workers",
        datePublished: "2024-12-18T06:26:18+00:00",
        dateModified: "2024-12-18T13:03:11+00:00",
        about: {
          "@id": "https://soulscale.org/#organization",
        },
        isPartOf: { "@id": "hhttps://soulscale.org/#website" },
        inLanguage: "en-US",
      },
    ],
  };
};
